module.exports = __webpack_public_path__ + "img/ppg.ce811885.png";